import { render } from "./cp_school_tag.vue?vue&type=template&id=a2ec861e&scoped=true"
import script from "./cp_school_tag.vue?vue&type=script&lang=js"
export * from "./cp_school_tag.vue?vue&type=script&lang=js"

import "./cp_school_tag.vue?vue&type=style&index=0&id=a2ec861e&scoped=scope&lang=less"

import exportComponent from "H:\\高报云\\HZY\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ec861e"]])

export default __exports__